import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../components/Card';
import { TrustScore } from '../components/TrustScore';
import { exchanges } from '../data/mockData';
export function ExchangesPage() {
  return <div className="min-h-screen bg-slate-50" data-id="element-350">
      <div className="bg-gradient-to-br from-slate-900 to-blue-900 text-white py-12" data-id="element-351">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-352">
          <h1 className="text-4xl font-bold mb-3" data-id="element-353">Top Crypto Exchanges</h1>
          <p className="text-slate-300 text-lg" data-id="element-354">
            Trusted reviews and comprehensive analysis of leading cryptocurrency
            exchanges
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-355">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-356">
          {exchanges.map(exchange => <Link key={exchange.id} to={`/exchange/${exchange.id}`} data-id="element-357">
              <Card className="p-6 h-full" hover data-id="element-358">
                <div className="flex items-start gap-4 mb-4" data-id="element-359">
                  <div className="flex items-center gap-3" data-id="element-360">
                    <span className="text-slate-500 font-semibold text-sm w-6" data-id="element-361">
                      {exchange.rank}
                    </span>
                    <img src={exchange.logo} alt={exchange.name} className="w-12 h-12 flex-shrink-0" data-id="element-362" />
                  </div>
                  <div className="flex-1" data-id="element-363">
                    <div className="flex items-center justify-between mb-2" data-id="element-364">
                      <h3 className="font-semibold text-xl" data-id="element-365">{exchange.name}</h3>
                      <TrustScore score={exchange.trustScore} size="sm" data-id="element-366" />
                    </div>
                    <p className="text-slate-600 text-sm line-clamp-2" data-id="element-367">
                      {exchange.description}
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-368">
                  <div data-id="element-369">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-370">
                      24h Volume
                    </div>
                    <div className="font-semibold" data-id="element-371">
                      ${(exchange.tradingVolume / 1000000000).toFixed(2)}B
                    </div>
                  </div>
                  <div data-id="element-372">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-373">
                      Supported Coins
                    </div>
                    <div className="font-semibold" data-id="element-374">
                      {exchange.supportedCoins}
                    </div>
                  </div>
                  <div data-id="element-375">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-376">
                      Trading Fee
                    </div>
                    <div className="font-semibold" data-id="element-377">{exchange.tradingFee}</div>
                  </div>
                  <div data-id="element-378">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-379">Reviews</div>
                    <div className="font-semibold" data-id="element-380">
                      {exchange.reviews.length} reviews
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap gap-2" data-id="element-381">
                  {exchange.features.slice(0, 3).map((feature, index) => <span key={index} className="text-xs bg-slate-100 text-slate-700 px-2 py-1 rounded" data-id="element-382">
                      {feature}
                    </span>)}
                  {exchange.features.length > 3 && <span className="text-xs text-slate-500 px-2 py-1" data-id="element-383">
                      +{exchange.features.length - 3} more
                    </span>}
                </div>
              </Card>
            </Link>)}
        </div>
      </div>
    </div>;
}